import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { theme } from "../../../utils/theme";

type RegisterSubmitButtonProps = {
  loading: boolean;
  disabled: boolean;
  onRegister: () => void;
};

export function RegisterSubmitButton({
  loading,
  disabled,
  onRegister,
}: RegisterSubmitButtonProps) {
  if (loading) {
    return (
      <LoadingButton
        sx={{
          display: "flex",
          margin: "auto",
          paddingLeft: 4,
          paddingRight: 4,
          width: 200,
          borderRadius: 10,
        }}
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined">
        <span>Save</span>
      </LoadingButton>
    );
  }

  return (
    <Button
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        borderRadius: 10,
        width: 200,
        display: "flex",
        margin: "auto",
        backgroundColor: "#e4e5e9",
        color: `${theme.palette.text.body}`,
        ":hover": { backgroundColor: "#e4e5e9" },
      }}
      disabled={disabled}
      type="submit"
      variant="contained"
      onClick={onRegister}>
      Register
    </Button>
  );
}
